<template>
  <svg
    width="16px"
    height="15px"
    viewBox="0 0 16 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>person-plus</title>
    <g
      id="Activity-Monitor"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1500.000000, -235.000000)"
        fill="#006F72"
        fill-rule="nonzero"
        id="Activity-Stream"
      >
        <g transform="translate(1467.000000, 0.000000)">
          <g
            id="Group-9"
            transform="translate(20.000000, 223.272727)"
          >
            <g
              id="person-plus"
              transform="translate(13.000000, 12.250000)"
            >
              <path
                d="M5.2000026,0 C3.21200161,0 1.6000008,1.61176081 1.6000008,3.6000018 C1.6000008,5.58824279 3.21200161,7.1999636 5.2000026,7.1999636 C7.18803559,7.1999636 8.8000364,5.58824279 8.8000364,3.6000018 C8.8000364,1.61176081 7.18803559,0 5.2000026,0 Z M5.2000016,1.6000008 C6.30480315,1.6000008 7.2000356,2.49544125 7.2000356,3.6000008 C7.2000356,4.70456235 6.30480315,5.5999228 5.2000016,5.6000008 C4.09520205,5.6000008 3.2000016,4.70456235 3.2000016,3.6000008 C3.2000016,2.49544125 4.09520205,1.6000808 5.2000016,1.6000008 Z M13.6000388,4.8000024 C13.1584386,4.8000024 12.8000384,5.15816258 12.8000384,5.6000028 L12.8000384,6.3999632 L12.000038,6.3999632 C11.5584378,6.3999632 11.2000376,6.75812338 11.2000376,7.1999636 C11.2000376,7.64180382 11.5584378,7.999964 12.000038,7.999964 L12.8000384,7.999964 L12.8000384,8.7999644 C12.8000384,9.24180462 13.1584386,9.6000448 13.6000388,9.6000448 C14.041639,9.6000448 14.4000392,9.24180462 14.4000392,8.7999644 L14.4000392,7.999964 L15.2000376,7.999964 C15.6416398,7.999964 16.00004,7.64180382 16.00004,7.1999636 C16.00004,6.75812338 15.6416398,6.3999632 15.2000376,6.3999632 L14.4000392,6.3999632 L14.4000392,5.6000028 C14.4000392,5.15816258 14.041639,4.8000024 13.6000388,4.8000024 Z M2.44960122,8.27500414 C0.982400491,8.88044444 0,10.3648452 0,12.000046 L0,13.6000468 C0,14.041807 0.358400179,14.4000472 0.8000004,14.4000472 L9.6000368,14.4000472 C10.041637,14.4000472 10.4000372,14.041807 10.4000372,13.6000468 L10.4000372,12.000046 C10.4000372,10.4034052 9.41203671,8.95500448 7.95043598,8.32492416 C7.74403587,8.23636412 7.50483575,8.23364412 7.30003565,8.32492416 C6.5920353,8.64228432 5.90240295,8.7998844 5.2000026,8.7999644 C4.5,8.7999644 3.8079939,8.63364432 3.07519354,8.29996415 C2.87359344,8.2082841 2.65440133,8.1907641 2.44960122,8.27500414 Z M2.75040138,9.90004495 C3.50560175,10.1867651 4.42480221,10.4001252 5.2000026,10.400045 C5.96880298,10.400045 6.83443542,10.2236451 7.57523579,9.95004498 C8.29683615,10.3618852 8.8000364,11.1195656 8.8000364,12.000046 L8.8000364,12.8000464 L1.6000008,12.8000464 L1.6000008,12.000046 C1.6000008,11.0682055 2.11680106,10.2708451 2.75040138,9.90004495 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
